define((require) => {
    "use strict";

    const {isBlank} = require("shared/util/StringUtils");

    const ParametersHelper = {

        PARAMETER_BEGIN: "#{",
        PARAMETER_END: "}",

        /**
         * Replaces the parameter placeholders with values of the parameters. <p>
         *
         * Example: Supplying "/product/#{Product ID}" and {"Product ID": "1234"} will return
         * "/product/1234". <p>
         *
         * Currently, we do not support the concept of mandatory parameters, so the returned value can be the
         * odd for empty parameters <b>unless</b> <tt>allowEmpty</tt> has explicitly been supplied as false,
         * in which case the empty string will be returned if just one parameter is empty. <p>
         *
         * Example: Supplying "/product/#{Product ID}" and {"Product ID": ""} or {"Some Else": "foo"} will return
         * the empty string for <tt>allowEmpty</tt> set to false; if truthy or undefined, the same template and
         * arguments would yield "/product/" (default behaviour).
         *
         * @param {String} template      A string with #{...} escape parameter placeholders; cannot be falsey.
         * @param {Object} args          A hash with name-value pairs, i.e. {"name1": "value1", "name2":
         *                               "value2", ...}. The values can be non-strings, will be coerced into Strings via
         *                               their <tt>toString()</tt> representations. Can be falsey/empty.
         * @param {Boolean} [allowEmpty] True or undefined to allow empty parameters (default), false otherwise; in the
         *                               latter case, just a single empty parameter will cause the empty string to be returned.
         *
         * @return {String}         The supplied template with inserted parameter values; will be the empty string
         *                          if just one parameter is empty/undefined and <tt>allowEmpty</tt> is falsey.
         */
        inject(template, args, allowEmpty) {
            let name;
            let value;

            if (args) {
                if (typeof allowEmpty === "undefined") {
                    allowEmpty = true;
                }
                for (name in args) {
                    value = args[name];

                    // eslint-disable-next-line eqeqeq
                    if (value == null) {
                        value = "";
                    } else {
                        value = value.toString();
                    }

                    if (isBlank(value) && !allowEmpty) {
                        return "";
                    }
                    template = template.replace(new RegExp(this.PARAMETER_BEGIN + name + this.PARAMETER_END, "g"), value);
                }
            }

            return template;
        }
    };

    return ParametersHelper;
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/ParametersHelper.js